import { render, staticRenderFns } from "./RebookingPassengers.vue?vue&type=template&id=6221ae57&scoped=true"
import script from "./RebookingPassengers.vue?vue&type=script&lang=js"
export * from "./RebookingPassengers.vue?vue&type=script&lang=js"
import style0 from "./RebookingPassengers.vue?vue&type=style&index=0&id=6221ae57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221ae57",
  null
  
)

export default component.exports